import { AfterViewInit, Directive, ElementRef, EventEmitter, NgZone, Output } from '@angular/core';

@Directive({
  selector: '[deferLoad]'
})
export class DeferLoadDirective implements AfterViewInit {
  @Output() public deferLoad: EventEmitter<any> = new EventEmitter();

  private _intersectionObserver?: IntersectionObserver;

  constructor(private _element: ElementRef, private zone: NgZone) {}
  public ngAfterViewInit() {
    this.zone.runOutsideAngular(() => {
      this._intersectionObserver = new IntersectionObserver((entries) => {
        this.checkForIntersection(entries);
      }, {});
      this._intersectionObserver.observe(<Element>this._element.nativeElement);
    });
  }
  private checkForIntersection = (entries: Array<IntersectionObserverEntry>) => {
    entries.forEach((entry: IntersectionObserverEntry) => {
      if (this.checkIfIntersecting(entry)) {
        this.deferLoad.emit();
        this.deferLoad.complete();
        this.deferLoad.unsubscribe();
        this._intersectionObserver.unobserve(<Element>this._element.nativeElement);
        this._intersectionObserver.disconnect();
      }
    });
  };
  private checkIfIntersecting(entry: IntersectionObserverEntry) {
    return (<any>entry).isIntersecting && entry.target === this._element.nativeElement;
  }
}
